import codeManage from "@/views/codeManage/index.vue";
import orderList from "@/views/order/list.vue";
import settlement from "@/views/order/settlement.vue";
import summary from "@/views/order/summary.vue";
import roleList from "@/views/system/roleList.vue";
import systemUser from "@/views/system/userList.vue";

const blankView = { render: (h) => h("router-view") };

export const asyncRoutes = [
  {
    path: "codeManage",
    component: blankView,
    meta: {
      title: "二维码管理",
      menu: true,
      icon: "el-icon-setting",
      permission: "code-manage",
    },
    children: [
      {
        path: "index",
        name: "codeManage",
        component: codeManage,
        meta: {
          title: "二维码",
          icon: "el-icon-share",
          permission: "code-manage-index",
        },
      },
    ],
  },
  {
    path: "orderManage",
    component: blankView,
    meta: {
      title: "订单管理",
      menu: true,
      icon: "el-icon-tickets",
      permission: "order-manage",
    },
    children: [
      {
        path: "list",
        name: "orderList",
        component: orderList,
        meta: {
          title: "渠道订单列表",
          icon: "el-icon-document",
          permission: "order-manage-list",
        },
      },
      {
        path: "settlement",
        name: "settlement",
        component: settlement,
        meta: {
          title: "结算明细列表",
          icon: "el-icon-notebook-2",
          permission: "order-manage-settlement",
        },
      },
      {
        path: "summary",
        name: "summary",
        component: summary,
        meta: {
          title: "结算汇总列表",
          icon: "el-icon-document-checked",
          permission: "order-manage-summary",
        },
      },
    ],
  },
  {
    path: "system",
    component: blankView,
    meta: {
      title: "系统设置",
      menu: true,
      icon: "el-icon-setting",
      permission: "system-manage",
    },
    children: [
      {
        path: "role",
        name: "roleList",
        component: roleList,
        meta: {
          title: "角色管理",
          icon: "el-icon-user-solid",
          permission: "role-list",
        },
      },
      {
        path: "user",
        name: "systemUser",
        component: systemUser,
        meta: {
          title: "系统用户",
          icon: "el-icon-user-solid",
          permission: "system-user",
        },
      },
    ],
  },
];
